// Editorial copy for category (cluster) pages. Keyed by category slug.
// Falls back to a generic description when a slug is absent.
export const categoryDescriptions: Record<string, string> = {
  'bank-statement-conversion':
    'Guides on converting PDF bank statements into Excel, CSV, and JSON — methods, formats, and per-bank steps.',
  'bank-reconciliation':
    'Everything about bank reconciliation: what it is, how to do it, templates, and importing statement data faster.',
  'bank-guides': 'How to download, export, and convert statements from specific banks.',
}

export function describeCategory(slug: string, label: string): string {
  return categoryDescriptions[slug] ?? `Articles about ${label}.`
}
